module.exports = __webpack_public_path__ + "img/pie-chart.80d04b22.svg";